import { LanguageToggler, globalSystemConstants } from "../../constants";
import { ToastifyService } from "../../services";
import { custom } from "./utilities";

export const changeLanguage = (config) => {
  return (dispatch) => {
    dispatch(
      custom(
        LanguageToggler.LANGUAGE_CHANGE,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    try {
      dispatch(custom(config, LanguageToggler.LANGUAGE_CHANGE));
    } catch (error) {
      ToastifyService.showError(error);
    } finally {
      dispatch(
        custom(
          LanguageToggler.LANGUAGE_CHANGE,
          globalSystemConstants.SPINNER_DEACTIVATE
        )
      );
    }
  };
};

export const languageChangeActions = {
  changeLanguage,
};
